import React, { useEffect, useState } from 'react'
import { Divider, Grid, Paper } from '@material-ui/core'
import { apiGetLoyaltyProviders } from '../../utils/api'

const BLAZE_GROWTH_PROVIDER = 'blaze-growth'

const baseTileStyle = {
  minWidth: 424,
  maxWidth: 424,
  height: 252,
  maxHeight: 252,
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  border: '1px solid #EEEEEE',
  borderRadius: 8,
  padding: 16,
}

const contentWrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
}

const contentWrapperDisabledStyle = {
  opacity: 0.5,
  pointerEvents: 'none',
}

const logoContainerStyle = {
  height: 42,
  display: 'flex',
  paddingBottom: 8,
}

const logoImgStyle = {
  maxHeight: 40,
  maxWidth: 120,
  objectFit: 'contain',
}

const contentStyle = {
  paddingTop: 8,
  flex: 1,
  overflow: 'hidden',
}

const nameStyle = {
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontSize: 16,
  fontWeight: 400,
  lineHeight: 1.5,
  letterSpacing: '0.00938em',
  margin: '0 0 0.35em',
  color: '#3E3F42',
}

const descriptionStyle = {
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.43,
  letterSpacing: '0.01071em',
  margin: '0 0 0.35em',
  color: '#9EA0A5',
}

const actionsStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
}

const learnMoreStyle = {
  pointerEvents: 'auto',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  backgroundColor: '#2CB2DC',
  color: '#ffffff',
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1.75,
  letterSpacing: '0.02857em',
  textTransform: 'uppercase',
  textDecoration: 'none',
  padding: '4px 10px',
  minWidth: 64,
  borderRadius: 4,
  boxShadow:
    '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
  cursor: 'pointer',
}

export const GrowthTile = ({ disabled }) => {
  const [provider, setProvider] = useState(null)

  useEffect(() => {
    apiGetLoyaltyProviders()
      .then((providers) => {
        const growth = (providers || []).find((p) => p.loyaltyProvider === BLAZE_GROWTH_PROVIDER)
        setProvider(growth || null)
      })
      .catch((err) => {
        console.error('Failed to fetch Blaze Growth provider', err)
        setProvider(null)
      })
  }, [])

  if (!provider) return null

  const wrapperStyle = disabled
    ? { ...contentWrapperStyle, ...contentWrapperDisabledStyle }
    : contentWrapperStyle

  return (
    <Grid item xs={12} sm={12} md={6} lg={6}>
      <Paper elevation={0} style={baseTileStyle}>
        <div style={wrapperStyle}>
          <div style={logoContainerStyle}>
            <img src={provider.logoUrl} alt={provider.name} style={logoImgStyle} />
          </div>
          <Divider />
          <div style={contentStyle}>
            <div style={nameStyle}>{provider.name}</div>
            <div style={descriptionStyle}>{provider.description}</div>
          </div>
        </div>
        <div style={actionsStyle}>
          <a href={provider.homepageUrl} target="_blank" rel="noreferrer" style={learnMoreStyle}>
            Learn More
          </a>
        </div>
      </Paper>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/GrowthTile/index.js